import { useSalesChannelContent } from 'src/hooks/useSalesChannelContent';
//import { useI18n } from 'src/hooks/useRouterChange';
//import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';
import {
  useEffect,
  useRef,
  //useEffect, useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useForms } from './useForms';
import sync from 'src/strategies/allProducts';
import { useRequest } from 'ahooks';
import defaultData from '../default';
import { useQueryLanguageListContentEditor } from '@/src/constrains/SalesChannelMultiLanguageSelect';
import {
  getAllProductsPage_revamp,
  getContentButtonThemes,
  postAllProductsPage_revamp,
} from '@/src/request/salesChannel/content';
import { msg } from '@/src/tools/message';
import { modal } from '@/src/utils/Modal';
import { i18nGet } from '@/src/tools/tools';
import { useI18n } from '@/src/hooks/useRouterChange';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { get } from 'lodash';
import { checkAll } from '../validator';
//import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
const useAllProductsPage = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    params,
    salesChannelMultiLanguageQueryParams,
    salesChannel,
    selectedLanguage,
    salesChannelMultiLanguageParams,
  } = useSalesChannelContent();
  const { pcForm, mobileForm, tabletForm } = useForms();
  const { saleChannelUuid, contentUuid } = params;
  const copyOfOriginal = useRef<any>(null);
  const _history = useHistory();
  const isLive =
    get(copyOfOriginal.current, 'salesChannelContent.status') === 'Live';
  const [hasModified, setHasModified] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const { data: buttons } = useRequest(() =>
    getContentButtonThemes(contentUuid),
  );

  const submitParams = salesChannelMultiLanguageParams;
  const queryParams = salesChannelMultiLanguageQueryParams;
  const currentLanguage = useQueryLanguageListContentEditor();

  const onGoBack = () => {
    _history.push(`/salesChannel/content/${saleChannelUuid}`);
  };

  const handleOnDataGet = (data) => {
    setLoaded(false);
    setHasModified(false);
    copyOfOriginal.current = data;
    if (!data?.pc && !data?.tablet && !data?.mobile) {
      pcForm.setFieldsValue(defaultData.pc);
      tabletForm.setFieldsValue(defaultData.tablet);
      mobileForm.setFieldsValue(defaultData.mobile);
    } else {
      const pcData = data?.pc;
      const tabletData = data?.tablet;
      const mobileData = data?.mobile;
      pcForm.setFieldsValue(pcData);
      tabletForm.setFieldsValue(tabletData);
      mobileForm.setFieldsValue(mobileData);
    }
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  };

  const { loading, run } = useRequest(
    (queryParams) => {
      return getAllProductsPage_revamp(contentUuid, queryParams);
    },
    {
      manual: true,
      onSuccess: handleOnDataGet,
    },
  );

  const { run: onSubmit } = useRequest(postAllProductsPage_revamp, {
    manual: true,
    onSuccess: (d) => {
      handleOnDataGet(d);
    },
  });

  const onFetch = (queryParams) => {
    setLoaded(false);
    setHasModified(false);
    run(queryParams);
  };

  const handleOnSubmit = async () => {
    const pD = pcForm.getFieldsValue();
    const tD = tabletForm.getFieldsValue();
    const mD = mobileForm.getFieldsValue();
    const pR = checkAll(pD);
    const tR = checkAll(tD);
    const mR = checkAll(mD);
    if (
      (!get(pR, 'hasError') &&
        !get(tR, 'hasError') &&
        !get(mR, 'hasError') &&
        isLive) ||
      !isLive
    ) {
      const data = {
        ...(copyOfOriginal.current || {}),
        pc: pD,
        tablet: tD,
        mobile: mD,
      };
      await onSubmit(data, submitParams);
      msg.success(getI18n('general.savesuccess'));
      setHasModified(false);
    } else {
      modal.error({
        title: getI18n('general.unabletosavechanges'),
        content: getI18n('general.fixerrors'),
        onOk: () => {
          return;
        },
      });
    }
  };

  useEffect(() => {
    onFetch(queryParams);
  }, [currentLanguage]);

  const handleValuesChange = (changeValues: any) => {
    if (loaded) setHasModified(true);
    sync(changeValues, { pcForm, tabletForm, mobileForm });
  };

  const handleOnReset = (fields: Array<any>, breakpoint) => {
    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(defaultData.tablet, key);
          return {
            name: key,
            value: v ? v : null,
          };
        }),
      );
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields
          .map((key) => {
            const v = get(defaultData.mobile, key);
            if (!!v) {
              return {
                name: key,
                value: v,
              };
            }
          })
          .filter((v) => !!v),
      );
    }
  };

  const handleOnCopy = (fields: Array<any>, breakpoint) => {
    const pcValues = pcForm.getFieldsValue(true);
    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
    }
  };

  const handleOnDiscard = async () => {
    if (hasModified) {
      //const data = submitData();
      //await handleAddDraft(selectedLanguage, data?.submitData);
    }
    onGoBack();
  };

  return {
    salesChannel,
    selectedLanguage,
    hasModified,
    loading,
    loaded,
    buttons,
    onGoBack,
    setHasModified,
    handleOnCopy,
    handleOnSubmit,
    handleOnReset,
    handleValuesChange,
    handleOnDiscard,
    pcForm,
    mobileForm,
    tabletForm,
    data: copyOfOriginal.current,
  };
};
export { useAllProductsPage };
